import { FC, Fragment, memo } from "react";
import { FormikHandlers } from "formik";
import {
  AutocompleteFilterBody,
  AutocompleteFilterBodyProps,
} from "../AutocompleteFilterBody";
import {
  FilterItem,
  Operator,
  ResourceType,
  useGetUsersMeOrganisationsCurrentResourceCreatorsQuery,
} from "../../../../../../../../services/cloudchipr.api";
import { FilterItemOperatorType } from "../../../FilterItemOperatorType";
import { getCreatedByFormattedValue } from "../../../../../../utils/helpers/getCreatedByFormattedValue";

interface CreatedByFilterProps extends AutocompleteFilterBodyProps {
  accountIds?: string[];
  resourceType: ResourceType;
  filter: FilterItem;
  operators?: Operator[];
  onChange: FormikHandlers["handleChange"];
}

export const CreatedByFilter: FC<CreatedByFilterProps> = memo(
  ({ resourceType, accountIds, operators, filter, onChange, ...props }) => {
    const { data, isLoading } =
      useGetUsersMeOrganisationsCurrentResourceCreatorsQuery({
        type: resourceType,
        // @ts-expect-error  //todo: this should be optional
        accountIds: accountIds?.length ? accountIds.join(",") : undefined,
      });
    return (
      <Fragment>
        <FilterItemOperatorType
          onChange={onChange}
          options={operators}
          value={filter.operator || "in"}
        />

        <AutocompleteFilterBody
          {...props}
          options={data ?? []}
          isLoading={isLoading}
          label="Created By"
          selectedValue={Array.isArray(filter?.value) ? filter.value : []}
          formatSelectedLabel={getCreatedByFormattedValue}
        />
      </Fragment>
    );
  },
);
